import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <div className="hero-section">
      <div className="hero-content">
        <h1>Welcome to Improving the Future</h1>
        <p>
          Empowering communities through education, innovation, and sustainable farming practices.
        </p>
        <div className="hero-buttons">
          <a href="/education" className="btn primary-btn">Learn About Our Educational Opportunities</a>
          <a href="/farming" className="btn secondary-btn">Explore Farming Posibilites</a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;